"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var InputWrapper = function (_a) {
    var children = _a.children, info = _a.info;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "input-wrapper", children: [children, info ? (0, jsx_runtime_1.jsx)("span", { children: info }) : ''] }));
};
exports.InputWrapper = InputWrapper;
